<template>
  <div class="card" @click="$emit('openItem')">
    <div class="card__img" :style="imgBackground">
      <slot name="img" />
    </div>
    <div class="card__content">
      <slot name="content" />
      <div class="card__main-button">
        <slot name="button" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupItemCard',
  props: {
    imgBackground: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex: 1;
  cursor: pointer;
  height: 96px;

  @include tablet {
    height: 104px;
  }
  @include desktop {
    height: 81px;
  }

  &:hover {
    .card__main-button {
      border-color: var(--white);
    }
    .card__content {
      background: linear-gradient(
        112.2deg,
        rgba(187, 188, 199, 0.4) -46.39%,
        rgba(187, 188, 199, 0) 112.38%
      );
    }
  }
  &:active {
    .card__main-button {
      color: var(--charcoal);
      background-color: var(--white);
    }
    .card__content {
      background: linear-gradient(
        111.02deg,
        rgba(18, 18, 18, 0.7) 3.86%,
        rgba(18, 18, 18, 0) 107.96%
      );
    }
  }

  &__img {
    display: none;

    @include tablet {
      display: flex;
      align-self: stretch;
      flex-direction: column;
      align-items: center;
      border-radius: 10px 0px 0px 10px;
      width: 133px;
      background-size: cover;
      color: var(--white);
    }
  }

  &__content {
    display: flex;
    flex: 1;
    border-radius: 10px;
    padding: 10px;
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );

    @include tablet {
      padding: 10px 20px;
      align-items: center;
      border-radius: 0px 10px 10px 0px;
    }
  }
  &__main-button {
    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--white);
    border: 1px solid var(--emperor-gray);
    border-radius: 8px;
    margin: 10px 0px 0px 5px;

    width: 40px;
    height: 40px;

    @include tablet {
      margin-top: 0px;
      width: 44px;
      height: 44px;
    }
    @include desktop {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
